<template>
    <div>

        <section class="content">
        <div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Administrasi OP Baru & Mutasi</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <select class="form-control" v-model="tab">
                                <option>Pendaftaran Objek Pajak Baru</option>
                                <option>Mutasi Objek Pajak/Wajib Pajak</option>
                            </select>
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <div v-if="tab == 'Pendaftaran Objek Pajak Baru'">
                    <bhumie_tab_pendaftaran_objek_pajak_baru></bhumie_tab_pendaftaran_objek_pajak_baru>
                </div>

                <div v-if="tab == 'Mutasi Objek Pajak/Wajib Pajak'">
                    <bhumie_tab_mutasi_objek_pajak_wajib_pajak></bhumie_tab_mutasi_objek_pajak_wajib_pajak>
                </div>

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: "Pendaftaran Objek Pajak Baru",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
